/* 
Notes:
02122022 (Hams) Created
*/
import { useAxios } from '../../hooks/useAxios';
import { useEffect, useState } from 'react';
import { useSessionStorage } from '../../hooks/useSessionStorage';

export function GetWorkatoRecipeByID(recipe_id) {
  const { data, loading, fetchNow } = useAxios();
  const [isFetching, setIsFetching] = useState(true);
  const [recipe, setRecipe] = useState(null);
  const [workato_id] = useSessionStorage('workatoId', '');

  useEffect(() => {
    if (loading) return;
    if (isNaN(recipe_id) || recipe_id === null || workato_id === null) return;

    const headers = {
      'Content-type': 'application/json',
      'x-user-email': 'integrations@arcanum.ai',
      'x-user-token': '62f4f964-1743-4667-88a3-6b2d2506a159',
    };

    if (isFetching) {
      fetchNow(`/api/platform/proxy?url=api/managed_users/${workato_id}/recipes/${recipe_id}`, 'GET', null, headers);
    } else {
      if (data?.id) {
        //console.log('recipe data - ', data);
        setRecipe(data);
      }
    }
    setIsFetching(false);
  }, [data, recipe_id, fetchNow, isFetching, loading, workato_id]);

  return recipe;
}
